var _path, _path2, _path3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 11C44.0001 11 44 36.0623 44 38C44 41.3137 35.0457 44 24 44C12.9543 44 4.00003 41.3137 4.00003 38C4.00003 36.1423 4 11 4 11",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 29C44 32.3137 35.0457 35 24 35C12.9543 35 4 32.3137 4 29",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20C44 23.3137 35.0457 26 24 26C12.9543 26 4 23.3137 4 20",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 10,
    rx: 20,
    ry: 6,
    fill: "none",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.61fcfcafe9a0d68be861f87f282c2838.svg";
export { ForwardRef as ReactComponent };